import { render, staticRenderFns } from "./tabelaPostagemFaixaAR.vue?vue&type=template&id=7988a000&scoped=true"
import script from "./tabelaPostagemFaixaAR.vue?vue&type=script&lang=js"
export * from "./tabelaPostagemFaixaAR.vue?vue&type=script&lang=js"
import style0 from "./tabelaPostagemFaixaAR.vue?vue&type=style&index=0&id=7988a000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7988a000",
  null
  
)

export default component.exports